import { defineStore } from "pinia";

import { PLACEHOLDER_UUID } from "@/utils/constants";
import { useUserStore } from "./user";
import { useTeamStore } from "./team";

import api from "@/api";

export const useDepartmentStore = defineStore("department", {
  state: () => ({
    loading: false,
    allDict: {},
    dropdownOptions: [],
  }),
  getters: {
    activeDepartments: (state) => {
      return Object.values(state.allDict).filter(
        (dpt) => dpt.is_deleted == false
      );
    },
    activeDepartmentsDict: (state) => {
      return state.activeDepartments.reduce((dict, dpt) => {
        dict[dpt._id] = dpt;
        return dict;
      }, {});
    },
    miscDepartment: (state) => {
      return state.activeDepartments
        .find(({ code }) => {
          return code === "Misc" || code === "misc";
        });
    },
  },
  actions: {
    /***
     * Fetch all departments for a specific organization
     */
    async fetchAll() {
      try {
        this.loading = true;
        // Fetch all departments
        const userStore = useUserStore();
        const activeOrganization = userStore.activeOrganization ?? null;
        const res = await api.department.fetchAll(activeOrganization);
        res.data = res.data.sort((a, b) => a.name.localeCompare(b.name));
        this.allDict = res.data.reduce((dict, department) => {
          dict[department._id] = department;
          return dict;
        }, {});

        // Pre computing drop down options for any select component
        // in the select, we add the organization name if the user has access to several organizations

        this.dropdownOptions = Object.values(this.allDict)
          .filter((dpt) => dpt.is_deleted == false)
          .map((dpt) => {
            let label = dpt.name;
            return {
              value: dpt._id,
              text: label,
            };
          });
        
        // console.log("dropdownOptions: ", this.dropdownOptions)
      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    getUserSupportDepartments(userId) {
      const teamStore = useTeamStore()
      const userTeamIds = new Set(teamStore.getUserTeams(userId).map(obj => obj._id))
      const res = [];
      for (let dpt of Object.values(this.allDict)) {
        if (dpt.support_leads_acc_ids.includes(userId) || userTeamIds.has(dpt.team_id)) {
          res.push(dpt);
        }
      }
      return res;
    },
    getUserTrainingDepartments: (userId) => {
      const res = [];
      for (let dpt of Object.values(this.allDict)) {
        if (dpt.training_approvers_acc_ids.includes(userId)) {
          res.push(dpt);
        }
      }
      return res;
    },
    // Returns department obj for a department id
    getDepartment(departmentId) {
      console.log("Available Departments: ", this.allDict);
      const departmentObj = this.dropdownOptions.filter(
        (department) => department.value === departmentId
      );

      return departmentObj;
    },
  },
});
